import axios from "axios";
import getApiBaseUrl from "helpers/getApiBaseUrl";
import IEmployeeData from "adminPanel/employee/models/IEmployee";
import { ISupervisor } from "amnPos/ticket/Ticket";

const baseUrl = getApiBaseUrl() + "employee/";

function GetEmployeeById(id: string) {
  return axios.get(baseUrl + id);
}

function EditEmployee(employee: IEmployeeData) {
  return axios.post<string>(baseUrl, employee);
}

function CreateEmployee(employee: IEmployeeData) {
  return axios.post<string>(`${baseUrl}new`, employee);
}

function DeleteEmployee(id: string) {
  return axios.post<string>(baseUrl + `delete`, [id]);
}

function GetSupervisorNameFromPinCode(pinCode: string, posId: string) {
  return axios.get<ISupervisor>(
    baseUrl + "get-supervisor-by-pin-code/" + pinCode + "/" + posId,
  );
}

interface IChangePassword {
  employeeId: string;
  password: string;
}

function ChangePassword(data: IChangePassword) {
  return axios.post(baseUrl + "change-password", data);
}

const EmployeeApi = {
  GetEmployeeById,
  CreateEmployee,
  EditEmployee,
  DeleteEmployee,
  GetSupervisorNameFromPinCode,
  ChangePassword,
};

export default EmployeeApi;
